import React from 'react';

export interface ImageProps {
  src: string;
  alt: string;
  srcSet?: Record<string, string>;
}

const Image: React.FC<ImageProps> = ({ srcSet, alt, ...props }) => {
  const parsedSrcSet =
    srcSet === undefined
      ? undefined
      : Object.entries(srcSet)
          .map(([res, src]) => `${src} ${res}`)
          .join(', ');
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <img srcSet={parsedSrcSet} alt={alt} {...props} />;
};

export default Image;
